const EXCLUDED_CONTEXT_SELECTORS = [
    '.footer__socialsColumn',
];

document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    applyExternalLinkStyling();
});

document.addEventListener('livewire:init', applyExternalLinkStyling);

function applyExternalLinkStyling() {
    var externalLinks = document.querySelectorAll('a[target="_blank"]:not([data-skip-external-icon="true"])');

    externalLinks.forEach(function (link) {
        if (link.classList.contains('btn--arrow')) {
            return;
        }

        var isExcluded = EXCLUDED_CONTEXT_SELECTORS.some(function (selector) {
            return link.closest(selector);
        });

        if (isExcluded) {
            return;
        }

        link.classList.add('link--external');

        var relParts = (link.getAttribute('rel') || '')
            .split(/\s+/)
            .filter(Boolean);

        if (!relParts.includes('noopener')) {
            relParts.push('noopener');
        }

        if (!relParts.includes('noreferrer')) {
            relParts.push('noreferrer');
        }

        link.setAttribute('rel', relParts.join(' '));
    });
}
